module.exports = __webpack_public_path__ + "img/logoDark.547e34d2.svg";